import {AddIcon, ChevronRightIcon, SearchIcon} from '@chakra-ui/icons';
import {
  Box,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import {BsRocketTakeoffFill} from 'react-icons/bs';
import {PiFlagCheckeredFill} from 'react-icons/pi';
import {sendJcWorldGoToOrCreate} from '../../../vuplex';
import {
  fontFamily,
  getWorldTypeAccentColor, worldTypes,
} from './config';
import {getCoverContent} from './coverContent';
import NewWorldCard from './NewWorldCard';
import OpenModalButton from './OpenModalButton';
import {useSelector} from 'react-redux';

const CoverPanel = ({
  onBrowse,
  onNewWorldClick,
  worldType,
}) => {
  const content = getCoverContent(worldType);
  const accentColor = getWorldTypeAccentColor({
    rules: {
      worldType,
    },
  });
  const handleGoToOrCreateClick = (worldType) => {
    sendJcWorldGoToOrCreate({
      worldType,
    });
  };

  const worlds = useSelector(s => s.worlds.worlds) || [];
  const worldCount = worlds.filter(w => w.rules?.worldType === worldType).length;

  return (
    <Stack
      border={`4px solid ${accentColor}`}
      bg="black"
      color="white"
      fontFamily={fontFamily}
      gap={2}
      h="full"
      justifyContent="center"
      minH={0}
      overflow="hidden"
      p={0}
    >
      <Stack gap={1} textAlign="center">
        <Heading
          color={accentColor}
          fontFamily={fontFamily}
          letterSpacing="0.1em"
          size="lg"
          textTransform="uppercase"
        >
          {content.title}
        </Heading>

        <Text
          paddingX="22%"
          fontSize="md"
          fontWeight="bold"
          lineHeight="1.2"
          fontFamily="Saira Variable"
        >
          {content.subtitle}
        </Text>
      </Stack>

      <Box bg="whiteAlpha.200" h="258px" overflow="hidden">
        <Image
          alt=""
          fallback={<Box h="full" bgGradient="linear(to-r, blue.500, purple.500)" />}
          h="full"
          objectFit="cover"
          src="TBD"
          w="full"
        />
      </Box>

      <Stack p={6} paddingY={0}>
        <NewWorldCard
          label={content.goToWorldLabel}
          rightIcon={worldType === worldTypes.craterRun ? <PiFlagCheckeredFill color="black" size="40px" /> : <BsRocketTakeoffFill color="black" size="40px" />}
          onClick={handleGoToOrCreateClick}
          worldType={worldType}
        />

        <Flex alignItems="center" color={accentColor} gap={2} p={2}>
          <Box bg="currentColor" flex={1} h="2px"/>
          <Text fontSize="xs" textAlign="center" textTransform="uppercase">
            or choose
          </Text>
          <Box bg="currentColor" flex={1} h="2px"/>
        </Flex>

        <Stack gap={2}>
          <OpenModalButton
            accentColor={accentColor}
            bgColor="#222"
            color="white"
            count={worldCount}
            label={content.browseLabel}
            leftIcon={<SearchIcon fontSize="20px"/>}
            onClick={onBrowse}
            rightIcon={<ChevronRightIcon fontSize="30px"/>}
            worldType={worldType}
          />

          <OpenModalButton
            bgColor="#222"
            color="white"
            label={content.createLabel}
            leftIcon={<AddIcon fontSize="20px"/>}
            onClick={onNewWorldClick}
            rightIcon={<ChevronRightIcon fontSize="30px"/>}
            worldType={worldType}
          />
        </Stack>
      </Stack>


    </Stack>
  );
};

export default CoverPanel;
